import PropTypes from "prop-types"
import { connect } from "react-redux"

import { switchCountry } from "app-store-v2/app/actions"

export default function withCountrySwitch(WrappedComponent) {
  const WithCountrySwitch = ({ doSwitchCountry, ...props }) => {
    const doSwitch = (country) => {
      doSwitchCountry(country)
    }

    return <WrappedComponent doSwitch={doSwitch} {...props} />
  }

  const mapStateToProps = () => {
    return {}
  }

  const mapDispatchToProps = (dispatch) => {
    return {
      doSwitchCountry: (country) => {
        dispatch(switchCountry(country))
      },
    }
  }

  WithCountrySwitch.propTypes = {
    doSwitchCountry: PropTypes.func,
  }

  return connect(mapStateToProps, mapDispatchToProps)(WithCountrySwitch)
}
